const API_URL = "https://app.tavad.com/hce/wp-json/wp/v2";

export async function getAllCita() {
  const authToken = sessionStorage.getItem( 'token' );
  try {
    const response = await fetch(`${API_URL}/cita`, {
      method: 'GET',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${ authToken }`,
      },
    } );
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
  }
}

export async function getCitaByID(postId) {
  const authToken = sessionStorage.getItem( 'token' );
  try {
    const response = await fetch(`${API_URL}/cita/${postId}`, {
      method: 'GET',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${ authToken }`,
      },
    } );
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
  }
}

export async function getCitasByEspecialista(especialistaId) {
  const authToken = sessionStorage.getItem( 'token' );
  try {
    const response = await fetch(`${API_URL}/cita?author=${especialistaId}`, {
      method: 'GET',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${ authToken }`,
      },
    } );
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
  }
}

export async function getCitasByFilters(tratamientoSelect, pacienteSelect, especialistaSelect) {
  if (!tratamientoSelect) {
    tratamientoSelect = '';
  }
  if (!pacienteSelect) {
    pacienteSelect = '';
  }
  if (!especialistaSelect) {
    especialistaSelect = '';
  }
  const authToken = sessionStorage.getItem( 'token' );
  try {
    const response = await fetch(`https://app.tavad.com/hce/wp-json/tavad/v2/citas?tipo=${tratamientoSelect}&pacientes=${pacienteSelect}&especialistas=${especialistaSelect}`, {
      method: 'GET',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${ authToken }`,
      },
    } );
    const data = await response.json();
    console.log(data);
    return data;
  } catch (error) {
    console.error(error);
  }
}

// export async function getAllCitaByTax(taxId) {
//   try {
//     const response = await fetch(`${API_URL}/cita?tratamiento=${taxId}&per_page=99`);
//     const data = await response.json();
//     return data;
//   } catch (error) {
//     console.error(error);
//   }
// }